export default "__VITE_ASSET__BqBCByqW__"